import React from 'react';
import { Facebook, Youtube, Instagram, Twitter, Linkedin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-50 text-gray-700 pt-16 pb-8 border-t border-gray-200 text-sm font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h4 className="font-bold text-lg text-black mb-6">BNM Wipers</h4>
            <p className="space-y-4">
                Making Every Corner Sparkle – Reliable Wipers for a Cleaner Home.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-lg text-black mb-6">News & Media</h4>
            <ul className="space-y-4">
              <li><a href="#" className="hover:text-blue-700 transition">Home</a></li>
              <li><a href="#about" className="hover:text-blue-700 transition">About</a></li>
              <li><a href="#products" className="hover:text-blue-700 transition">Products</a></li>
            </ul>
          </div>

          <div id='contact'>
            <h4 className="font-bold text-lg text-black mb-6">Contact Us</h4>
            <div className="space-y-4 leading-relaxed text-gray-600">
              {/* <p>
                BNM HOUSE, Plot No. 42, Industrial Area,<br />
                Phase 2, New Delhi - 110020. India.
              </p> */}
              <p>
                KH. No. 328 Laxmi Garden, Arya Nagar,<br/>
                Loni  Ghaziabad - 201102 <br/>
              </p>
              
              <p className="flex items-center font-medium text-black">
                <span className="w-20 text-gray-500 font-normal">Phone: </span> +91-9891451698
              </p>
              
              <p className="flex items-center font-medium text-black">
                <span className="w-20 text-gray-500 font-normal">Email: </span> bnmwiper@gmail.com
              </p>
            </div>
          </div>
            <div>
              <h4 className="font-bold text-lg text-black mb-6">Follow Us: </h4>
              <div className="leading-relaxed text-gray-600">{/* space-y-4 */}
                <div className="flex text-gray-600 mb-4 d-flex justify-start items-center">{/* space-x-5 */}
                  <a className="hover:bg-blue-600 hover:text-white p-3 rounded-full transition"><Facebook size={20} /></a>
                  <a className="hover:bg-red-600 hover:text-white p-3 rounded-full transition"><Youtube size={20} /></a>
                  <a className="hover:bg-pink-600 hover:text-white p-3 rounded-full transition"><Instagram size={20} /></a>
                  <a className="hover:bg-black hover:text-white p-3 rounded-full transition"><Twitter size={20} /></a> 
                </div>
                <a
                  href={`https://wa.me/919891451698?text=Hello!%20I%20want%20to%20enquire%20about%20your%20products.`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-block w-full bg-blue-700 hover:bg-blue-800 text-white font-bold px-6 py-3 rounded-full text-center transition transition-all duration-300 hover:scale-105"
                >Contact Us On <i className="fa-brands fa-whatsapp"></i>
                </a>
              </div>
            </div>
        </div>

        <div className="border-t border-gray-200 pt-8 mt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500 w-full text-center">
           <p className='text-center w-full'>© 2025 BNM WIPERS. ALL RIGHTS RESERVED.</p>
           {/* <div className="flex space-x-6 mt-4 md:mt-0">
             <a href="#" className="hover:text-blue-700">Terms & Conditions</a>
             <a href="#" className="hover:text-blue-700">Privacy Policy</a>
             <a href="#" className="hover:text-blue-700">Sitemap</a>
           </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;